module.exports = __webpack_public_path__ + "static/media/kay_rauber_mood.05634713.jpg";